/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierCT-react/config/PremierCT-wizard-config.json5";
// import { LoadSaveService } from 'gw-capability-quoteandbind';
import metadata from './BuildersRiskPage.metadata.json5';
import messages from './BuildersRiskPage.messages';
import styles from './BuildersRiskPage.module.scss';
import ProductCoverageSelectionComponent from '../../components/BuildersRisk/ProductCoverageSelection/ProductCoverageSelectionComponent'
import ProjectComponent from '../../components/BuildersRisk/Project/ProjectComponent'
import ProjectSpecificCglComponent from '../../components/BuildersRisk/ProjectSpecificCgl/ProjectSpecificCglComponent';
import RenovationsComponent from '../../components/BuildersRisk/Renovations/RenovationsComponent';
import GeneralContractorComponent from '../../components/BuildersRisk/GeneralContractor/GeneralContractorComponent';
import ExistingStructureComponent from '../../components/BuildersRisk/ExistingStructure/ExistingStructureComponent';
import ConstructionAlreadyCommencedComponent from '../../components/BuildersRisk/ConstructionAlreadyCommenced/ConstructionAlreadyCommencedComponent';
import BlanketCocComponent from '../../components/BuildersRisk/BlanketCoc/BlanketCocComponent';

function BuildersRiskPage(props) {
    const {
        showConfirm
    } = useModal();

    const { wizardData: submissionVM, updateWizardData, changeNextSteps, steps, currentStepIndex } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName,jobTypes } = PremierConstants;
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'))
    const liabilitycoveragesStep = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('liabilitycoverages'))
    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('BuildersRiskPage');


    const onNext = useCallback(
            async () => {
    
                const {jobType} = submissionVM.value.baseData;
    
                if (!_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.proFie)
                    && submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.proFie) {
                    if (_.filter(steps, (step) => step.id.includes('property')).length === 0) {
                        if(jobType === jobTypes.policyChange ) {
                            steps.splice(4, 0, propertySteps[0], propertySteps[1]);
                            changeNextSteps(steps.slice(3, 10))
                        } else {
                            steps.splice(5, 0, propertySteps[0], propertySteps[1]);
                            changeNextSteps(steps.slice(4, 13))
                        }
                    }
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (_.filter(steps, (step) => step.id.includes('property')).length !== 0) {
                        let startStep = 0

                        if(jobType === jobTypes.policyChange ) {
                            if(_.find(steps, (step) => step.id.includes('locations')) >= 0) {
                                startStep = 4
                            } else {
                                startStep = 3
                            }
                        } else {
                            startStep = 4
                        }

                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(startStep, 12))
                    }
                }

                if(!_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.liaFie) &&
                    submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.liaFie && 
                    !_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie) && 
                    submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie !== 'Bla') {
                        _.remove(steps, (step) => step.id === 'liabilitycoverages')
                            
                        steps.splice(currentStepIndex + 1, 0, liabilitycoveragesStep[0])
                        
                        changeNextSteps(steps.slice(currentStepIndex + 1, steps.length))
                } else {
                    _.remove(steps, (step) => step.id === 'liabilitycoverages')

                    changeNextSteps(steps.slice(currentStepIndex + 1, steps.length))
                }
    
                const {productCode} = submissionVM.value.baseData;
                const lobLineName = lineName[productCode];
    
                submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);
    
                return submissionVM;
            },
            [submissionVM, updateSubmission]
        );

    const overrideProps = {
        productCoverageSelection: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection"
        },

        project: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.project"
        },

        projectSpecificCgl: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: !_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.doyouwistorecquofoCGLFie)
                && (submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.doyouwistorecquofoCGLFie
                || submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie === 'ProSpeCGLonl'),
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.projectSpecificCgl"
        },
        
        renovations: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.renovations",
            visible: _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.project.doeTheProInCAnyRenFie')
        }, 

        generalContractor: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.generalContractor"
        }, 

        existingStructure: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.existingStructure",
            visible: _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.project.doYouReqCovOnExistStrFie')
        },

        constructionAlreadyCommenced: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.constructionAlreadyCommenced",
            visible: _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.project.hasTheProAlrStaFie')
        },

        blanketCoc: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: submissionVM.lobData.consTraAndServLine.coverables.buildersRisk?.productCoveragesSelection?.typofInsReqFie?.value?.code === 'Bla',
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.consTraAndServLine.coverables.buildersRisk.blanketCoc"
        },
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelection: ProductCoverageSelectionComponent,
            project: ProjectComponent,
            projectSpecificCgl: ProjectSpecificCglComponent,
            renovations: RenovationsComponent,
            generalContractor: GeneralContractorComponent,
            existingStructure: ExistingStructureComponent,
            constructionAlreadyCommenced: ConstructionAlreadyCommencedComponent,
            blanketCoc: BlanketCocComponent

        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM);
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');
            
            validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.consTraAndServLine?.coverables?.buildersRisk?.value, ' ');

            const lobLineName = productCode ? lineName[productCode] : '';

            await updateSubmission(lobLineName, 'BuildersRiskPage', subVMCopy);
            
            return submissionVM;
        },
        [submissionVM]
    );

    const isDisableNext = () => !submissionVM.lobData.consTraAndServLine.coverables.buildersRisk.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

BuildersRiskPage.propTypes = wizardProps;
export default withRouter(BuildersRiskPage);
